import { toast } from 'react-toastify'

import { ICurrentCourse, ICurrentModule } from '../interfaces/IStateHome'
// import Notification, { type } from "../../../shared/toast/Toast";

export const controllerGetCurrent = (result: any) => {
    try {
        console.log('RESULTADO: ', result)

        const cursos_actuales: ICurrentCourse[] = result.map((res: any) => {
            const modulos: ICurrentModule[] = res.modules.map((mod: any, i: number) => {
                const resp: ICurrentModule = {
                    id: mod._id,
                    buyed: mod.buyed,
                    indice_modulo: `Modulo ${i + 1}`,
                    nombre_modulo: mod.name,
                }

                return resp
            })

            const modulos_comprados = modulos.filter((m) => m.buyed !== false)

            const current: ICurrentCourse = {
                id: res.id,
                modulos: modulos_comprados,
                nombre: res.name,
                total: res.modules.length,
            }

            return current
        })

        return cursos_actuales
    } catch (error) {
        // Notification( type.danger, `Error al mapear los datos en GetCurrentCourses: ${error}` );
        toast.error(`Error al mapear los datos en GetCurrentCourses: ${error}`)
    }
}
